import { render, staticRenderFns } from "./contests.vue?vue&type=template&id=79690819&"
import script from "./contests.vue?vue&type=script&lang=js&"
export * from "./contests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports